import React, { useEffect, useState } from "react";
import "./style.css";
import AllDropDownsAHSF from "../AllDropDownsAHSF";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllYesNoList,
  GetAllYesNoListByTaskGuid,
  UpdateYesNoList,
} from "../../Redux/Reducers/YesNoManager";
import { GetYesNoTableData } from "../../Services/YesNoTableManager/GetYesNoTableData";

const YesNoTable = (props) => {
  // State for storing configuration data
  const [jsonData, setJsonData] = useState();
  const [Refresh, setRefresh] = useState(false);

  // Function to fetch configuration data
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };

  // Load configuration data when component mounts
  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch();
  const state = useSelector((state) => ({
    YesNoManager: state.YesNoManager.YesNoManager,
    ApplicationInformation: state.ApplicationInformation.ApplicationInformation,
    YesNoManagerUpdate: state.YesNoManager.YesNoManagerUpdate,
  }));

  // State for storing Yes/No data
  const [YesNoList, setYesNoList] = useState([]);

  // Function to fetch Yes/No table data
  const getYesNoData = async () => {
    let data = await GetYesNoTableData(props.taskId);
    setYesNoList(data.data.result);
  };

  // Load Yes/No table data when component mounts or Refresh changes
  useEffect(() => {
    getYesNoData();
  }, [Refresh]);

  // Function to group questions by group name
  const qustionGroup = () => {
    const yesNoList = {};

    YesNoList.forEach((elem) => {
      if (!yesNoList[elem["questionGroupName"]]) {
        yesNoList[elem["questionGroupName"]] = [];
      }
      yesNoList[elem["questionGroupName"]].push(elem);
    });
    return yesNoList;
  };

  // Function to handle input blur events and update the list
  const handleOnBlur = async (fieldName, value, id) => {
    const updatedList = [...YesNoList];
    setRefresh(false);

    const targetIndex = updatedList.map((item) => {
      if (item["yesNoEvaluationGUID"] == id) {
        if (fieldName == "evalYesNo") {
          return {
            ...item,
            [fieldName]: JSON.parse(value),
          };
        } else {
          return {
            ...item,
            [fieldName]: value,
          };
        }
      }
      return item;
    });

    const updated = await dispatch(UpdateYesNoList(targetIndex));

    // Refresh the table after update
    if (updated.payload) {
      setRefresh(true);
    }
  };

  return jsonData ? (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title"> {jsonData?.yesNoTableTitle}</p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr>
                <th>{jsonData?.marksTableStandard}</th>
                <th>الاجابة</th>
                <th> {jsonData?.marksTableComment}</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(qustionGroup()).map((group, groupIndex) => {
                return (
                  <React.Fragment key={groupIndex}>
                    <tr>
                      <th className="PointRow" colSpan="4">
                        {group}
                      </th>
                    </tr>
                    {qustionGroup()[group].map((marksOpj, index) => {
                      return (
                        <tr key={marksOpj.yesNoEvaluationGUID}>
                          <td>{marksOpj.questionName}</td>
                          <td>
                            <AllDropDownsAHSF
                              fieldsName="yesNoTableDropDown"
                              yesNo={true}
                              hidelable={true}
                              show={true}
                              disabled={props.disabled}
                              dropdownType="normal"
                              arrayOoptionList={[
                                { text: "نعم", value: true },
                                { text: "لا", value: false },
                              ]}
                              value={marksOpj.evalYesNo}
                              KeyText={"text"}
                              KeyValue={"value"}
                              onChange={(e) => {
                                handleOnBlur(
                                  "evalYesNo",
                                  e.target.value,
                                  marksOpj.yesNoEvaluationGUID
                                );
                              }}
                            />
                          </td>
                          <td>
                            <textarea
                              className="textareaMarksAndYesNo"
                              defaultValue={marksOpj.evalReason}
                              onChange={(e) => {
                                handleOnBlur(
                                  "evalReason",
                                  e.target.value,
                                  marksOpj.yesNoEvaluationGUID
                                );
                              }}
                              onBlur={(e) =>
                                handleOnBlur(
                                  "evalReason",
                                  e.target.value,
                                  marksOpj.yesNoEvaluationGUID
                                )
                              }
                              disabled={props.disabled}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default YesNoTable;
